export const normalizeZipCode = (value) => {
  if (!value) return value;
  return value.toUpperCase().substring(0, 10);
};
